import React, {useContext} from 'react';
import PropTypes from 'prop-types';

import Badge from "components/Badge";
import RightDrawer from "components/WMS/Mobile/RightDrawer";
import RightDrawerDesktop from "components/WMS/Desktop/RightDrawerDesktop";

import ProductProblemDrawer from "../ProductProblemDrawer";
import ShipmentInfosHeader from "./components/ShipmentInfosHeader";
import CarrierIcon from "./components/CarrierIcon";
import ToBeCancelled from "components/WMS/ToBeCancelled";

import {WMSContext} from "../../../../../../context/WMSContext";
import {PackingContext} from "../../../PackingContext";
import {FormattedMessage} from "react-intl";
import {packingStepNames} from "../../../packingSteps";
import {WmsItemsStatus} from "utils/WmsItemsStatus";
import {Grid} from "@mui/material";
import {BarCodeScannerContext} from "../../../../../../../../contexts/barCodeScannerContext";


SelectedItemPackingDrawer.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    packingStep: PropTypes.object.isRequired,
    hideCloseIcon: PropTypes.bool,
    footer: PropTypes.element
};

function SelectedItemPackingDrawer({open, handleClose, packingStep, footer = null, hideCloseIcon = false, ...props}) {
    const {isMobile} = useContext(WMSContext)
    const {setEnableScan} = useContext(BarCodeScannerContext)
    const {
        openProductProblemDrawer,
        setOpenProductProblemDrawer,
        isMultiSessionPacking,
        handleAllItemAreCancelled,
        setPackingStep,
        getItemIndex,
        openToBeCancelledModal,
        setOpenToBeCancelledModal,
        toBeCancelledItem,
        setPackingLoading
    } = useContext(PackingContext);

    function updatePackingStepAfterItemWasPutAway(itemIndex) {
        let tempShipment = {...packingStep.selectedShipment}
        let lineItem = tempShipment.lineItems[itemIndex]
        lineItem.isPacked = false
        lineItem.wmsItem.status = WmsItemsStatus.TO_BE_CANCELLED
        lineItem.isCancelled = true
        lineItem.itemsCancelled++

        let allItemAreCancelled = tempShipment.lineItems.every((lineItem) => lineItem.isCancelled)

        if (allItemAreCancelled) {
            handleAllItemAreCancelled()
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
        } else {
            setPackingStep({
                ...packingStep,
                selectedShipment: tempShipment
            })
        }
    }

    const handleCloseToBeCancelledModal = (isItemPutAway = false) => {
        setPackingLoading(false)
        setOpenToBeCancelledModal(false)
        setEnableScan(true)
        if (isItemPutAway) {
            updatePackingStepAfterItemWasPutAway(getItemIndex(toBeCancelledItem.barcode))
        }
    }

    const drawerContent = (
        <>
            {props.children}
            {openProductProblemDrawer.isOpen && (
                <ProductProblemDrawer
                    open={openProductProblemDrawer.isOpen}
                    handleClose={() => setOpenProductProblemDrawer({
                        ...openProductProblemDrawer,
                        isOpen: false
                    })}
                    product={openProductProblemDrawer.product}
                    handleProductCancelled={openProductProblemDrawer.handleProductCancelled}
                />
            )}
            {openToBeCancelledModal && toBeCancelledItem && (
                <ToBeCancelled
                    item={toBeCancelledItem}
                    open={openToBeCancelledModal}
                    handleClose={handleCloseToBeCancelledModal}
                />
            )}
        </>
    )

    if (isMobile) {
        return (
            <RightDrawer
                open={open}
                handleClose={handleClose}
                headerCenterContent={<ShipmentInfosHeader selectedShipment={packingStep.selectedShipment} />}
                strictOnClose={hideCloseIcon}
                hideCloseIcon={hideCloseIcon}
                footer={footer}
            >
                {drawerContent}
            </RightDrawer>
        )
    } else {
        return (
            <RightDrawerDesktop
                open={open}
                onClose={handleClose}
                withoutHeadBorder={true}
                strictOnClose={hideCloseIcon}
                hideCloseIcon={hideCloseIcon}
                title={
                    <Grid
                        container
                        justifyContent={"space-between"}
                    >
                        <ShipmentInfosHeader selectedShipment={packingStep.selectedShipment} />
                    </Grid>
                }
                footer={footer}
            >
                {drawerContent}
            </RightDrawerDesktop>
        );
    }
}

export default SelectedItemPackingDrawer;
